"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvalidateRefundEligibilityCheckLegacyQuery = exports.useRefundEligibilityCheckLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_query_1 = require("react-query");
var core_1 = require("../../../core");
function cacheKey(accountId) {
    return "cx-refund-eligibility-check-".concat(accountId);
}
function useInvalidateRefundEligibilityCheckLegacyQuery(accountId) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return function () { return queryClient.invalidateQueries(cacheKey(accountId)); };
}
exports.useInvalidateRefundEligibilityCheckLegacyQuery = useInvalidateRefundEligibilityCheckLegacyQuery;
function useRefundEligibilityCheckLegacyQuery(accountId, customerId, options) {
    var api = core_1.configService.getConfig().api;
    var url = "".concat(api.baseUrl, "/pace-self-serve-refunds/v1/accounts/").concat(accountId, "/owners/").concat(customerId, "/eligible");
    return (0, ui_tools_1.useReactQuery)(cacheKey(accountId), function () {
        return core_1.apiService.get({
            url: url,
        });
    }, options);
}
exports.useRefundEligibilityCheckLegacyQuery = useRefundEligibilityCheckLegacyQuery;
